// styles
import { chartDashboardBoxStyle, chartDashboardType03Style } from 'styles';

// libraries
import styled from 'styled-components';

interface StyledWeeklyEntryProps {
  $canvasHeight: number;
}

export const StyledWeeklyEntry = styled.div<StyledWeeklyEntryProps>`
  ${chartDashboardBoxStyle}
  ${chartDashboardType03Style}
    
    .entry-graph {
    margin-left: 0;

    > canvas {
      width: 891px;
      height: ${({ $canvasHeight }) => $canvasHeight}px;
    }
  }
`;
